export default {
  headerLineHeight: 'lg',
};
